// replace with game.route
export const convertTitleToUrl = (str: string): string => {
  return str
    .toString()
    .replace(/\s-\s/g, ' ')
    .replace(/[&/\\#,+()$~%.'":*?<>{}]/g, '')
    .replace(/\s+/g, '-')
    .toLowerCase()
}

export const getQueryFromRoute = (route: string): string[] | null => {
  const regex = /\[.+?\]/g
  // get all dynamic query params from url
  const matches = route.match(regex)

  return matches
}

export const generateShareUlrWithUserId = (userId: string): string => {
  const { host } = window.location

  return `${host}/${userId ? `?invited_by=${encodeURIComponent(userId)}` : ''}`
}
